<!--
* 组件名 : 调用远程图片
* 开发者 : HN
*
* 参数:
* path  {String}  图片相对路径
*
* 事件:
* 无
-->

<template>
  <img
    :src="imgUrl"
    :data-slug="slug"
    v-bind="$attrs"
    v-on="$listeners"
    @load="on_load"
    ref="imgEl"
  />
</template>

<script>
import { i18n } from "utils/util";
export default {
  name: "v-img",
  props: {
    path: {
      type: String,
      required: true,
    },
    slug:{
      type: String,
      default: ""
    }
  },
  data() {
    return {
      imgUrl: i18n(this.path),
    };
  },
  watch: {
    path(value) {
      this.imgUrl = i18n(value);
    },
  },
  methods: {
    on_load() {
      let newImg = new Image();
      newImg.onload = () => {
        this.$refs.imgEl.dataset.originHeight = newImg.height;
        this.$refs.imgEl.dataset.originWidth = newImg.width;
        this.$emit("loadDone");
      };
      newImg.src = this.imgUrl;
    },
  },
};
</script>

<style></style>
